import { GET } from './http'

export const getIframeUrl = async (url) => {
  const result = await GET(url)
  return result.url
}
